import React, { Component, PropTypes } from 'react';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import BFWOfferCard from './BFWOfferCard';

export default class BFWOffersSection extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.bfwOffers.isLoaded) {
      return <span />
    }

    let bfwOffers = this.props.bfwOffers;

    let offers = bfwOffers.map((offerItem, idx) => {
      return <div className="offerCard-outerWrapper">
        <BFWOfferCard key={offerItem.id}
          offerId={offerItem.id}
          orgLogoUrl={offerItem.org_logo_url}
          organizationName={offerItem.organization_name}
          title={offerItem.title}
          thumbNailCopy={offerItem.thumbnail_copy}
          expiration={offerItem.expiration_formatted}
          website={offerItem.website}
          never_expires={offerItem.never_expires}
        />
        </div>;

    });

    return(
      <div className="BFWOffers-innerWrapper">
        <h2 className="page-header">Top offers, deals &amp; promo codes for WorldWideWomen members</h2>
        <div className="BFWOffers-offersWrapper">


          {offers}
        </div>
      </div>

    );
  }
};



// WEBPACK FOOTER //
// ./src/components/bfwOffers/BFWOffersSection.jsx